var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "login-container" },
    [
      _c("logo"),
      _vm._v(" "),
      _c("div", { staticClass: "wtw-container" }, [
        _c(
          "form",
          { staticClass: "wtw-form" },
          [
            _c("div", { staticClass: "input-container" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.user.email,
                    expression: "user.email"
                  }
                ],
                attrs: { type: "text", placeholder: "Email", name: "email" },
                domProps: { value: _vm.user.email },
                on: {
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.user, "email", $event.target.value)
                    },
                    function($event) {
                      _vm.errorMessage = null
                    }
                  ]
                }
              }),
              _vm._v(" "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errors.has("email"),
                      expression: "errors.has('email')"
                    }
                  ],
                  staticClass: "error-message"
                },
                [_vm._v(_vm._s(_vm.errors.first("email")))]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "input-container" }, [
              _c("input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  },
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.user.password,
                    expression: "user.password"
                  }
                ],
                attrs: {
                  type: "password",
                  placeholder: "Password",
                  name: "password"
                },
                domProps: { value: _vm.user.password },
                on: {
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.user, "password", $event.target.value)
                    },
                    function($event) {
                      _vm.errorMessage = null
                    }
                  ]
                }
              }),
              _vm._v(" "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errors.has("password"),
                      expression: "errors.has('password')"
                    }
                  ],
                  staticClass: "error-message"
                },
                [_vm._v(_vm._s(_vm.errors.first("password")))]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "input-container",
                staticStyle: { "margin-left": "20px" }
              },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.user.rememberMe,
                      expression: "user.rememberMe"
                    }
                  ],
                  staticClass: "ios-toggle",
                  attrs: {
                    type: "checkbox",
                    name: "remember-me",
                    id: "remember-me"
                  },
                  domProps: {
                    checked: Array.isArray(_vm.user.rememberMe)
                      ? _vm._i(_vm.user.rememberMe, null) > -1
                      : _vm.user.rememberMe
                  },
                  on: {
                    change: function($event) {
                      var $$a = _vm.user.rememberMe,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(_vm.user, "rememberMe", $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.user,
                              "rememberMe",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.user, "rememberMe", $$c)
                      }
                    }
                  }
                }),
                _vm._v(" "),
                _c("label", {
                  staticClass: "checkbox-label",
                  attrs: { for: "remember-me", "data-label": "Remember me" }
                })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "button pink",
                class: {
                  disabled:
                    _vm.errors.has("password") || _vm.errors.has("email")
                },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.logUserIn(_vm.user)
                  }
                }
              },
              [_vm._v("\n                Log In\n            ")]
            ),
            _vm._v(" "),
            _c(
              "router-link",
              {
                staticClass: "password-reset",
                attrs: { to: "/account/send-reset-email" }
              },
              [_vm._v("\n                Forgot Password?\n            ")]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "span",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.errorMessage,
                expression: "errorMessage"
              }
            ],
            staticClass: "error-message"
          },
          [_vm._v(_vm._s(_vm.errorMessage))]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "back-button",
          on: {
            click: function($event) {
              $event.stopPropagation()
              return _vm.$router.go(-1)
            }
          }
        },
        [_vm._v("\n        Back\n    ")]
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.loggingIn,
                expression: "loggingIn"
              }
            ],
            staticClass: "loading-overlay"
          },
          [_c("loader")],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-178ddd5c", { render: render, staticRenderFns: staticRenderFns })
  }
}